var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-tree", {
        ref: "tree",
        staticClass: "permission-tree",
        attrs: {
          "check-strictly": _vm.checkStrictly,
          data: _vm.routesData,
          props: _vm.defaultProps,
          "default-checked-keys": _vm.acl && JSON.parse(_vm.acl),
          "show-checkbox": "",
          "highlight-current": "",
          "default-expand-all": "",
          "node-key": "path"
        },
        on: { check: _vm.handleCheck }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }